export default __webpack_public_path__ + "static/media/info.4aa12471.svg";